export type Address = {
  country: string;
  line1: string;
  line2: string;
  line3: string;
};

export const OFFICES: { [key: string]: Address } = {
  GB: {
    country: "United Kingdom",
    line1: "Suite 14, 2nd Floor, The Spire",
    line2: "Pilgrim Street",
    line3: "Newcastle Upon Tyne, NE1 2DS",
  },

  CA: {
    country: "Canada",
    line1: "Suite 1004, Bankers Hall West Tower",
    line2: "888 3rd Street SW",
    line3: "Calgary, Alberta, T2P 5C5",
  },

  PL: {
    country: "Poland",
    line1: "Loftmill, Sagittarius Business House",
    line2: "Sucha Street 2",
    line3: "Wroclaw, 50-086",
  },
};
